import {db} from "../../firebase";
import {Collections} from "../collections";

export const addStudentSoftSkillsFeedback = (doc) => {
    return db.collection(Collections.STUDENT_SOFT_SKILLS_FEEDBACK).add(doc);
};